import styled from 'styled-components';

const StyledBadge = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: row;

  background-color: ${(props) => props.theme.colors.primary.dark};
  border: 3px solid white;
  border-radius: 100%;
  color: white;

  font-weight: bold;
  font-size: 13px;

  height: 28px;
  width: 28px;
`;

export default StyledBadge;
